import React, { useEffect, useState } from 'react';
import Alert from './Alert';
import ItemWConf from './ItemWConf';
import { FiPlusCircle, FiEdit } from "react-icons/fi"
import { Link } from "react-router-dom"


import { db, auth } from '../functions/firebaseFunctions'
export default function VenuesTab(props) {

    const { setUserState, mobilePay } = props;
    const [actVs, setActVs] = useState(null);
    const [vensBks, setVensBks] = useState(null);
    const [vensBksCount, setVenueBksCount] = useState(null);
    const uid = auth.currentUser?.uid;
    const [Err, setErr] = useState(null);
    const [alert, setAlert] = useState(null);
    useEffect(() => {
        getData();
    }, []);
    const getData = async () => {
        db.collection('venue')
            .where('owner', '==', auth.currentUser?.uid)
            .get()
            .then((doc) => {
                if (!doc.empty) {
                    const vensArr = [];
                    let counter = 0;
                    let max = doc.docs.length;
                    doc.docs.forEach(ven => {
                        vensArr.push(ven.data());
                        counter++;
                        if (counter === max) {
                            setActVs(vensArr);
                        }
                    });
                }
            }).catch(err => console.log('err', err));

        await db.collection('access').doc(uid).get()
            .then((res) => {

                if (res.exists) {
                    const v = res.data();
                    const bks = [];
                    let arr1 = [];
                    var count = 0;
                    for (const [eventId, type] of Object.entries(v)) {
                        if (type === 'venues') {
                            db.collection('bookings').doc(eventId).get().then(async (booking) => {

                                let bookingVal = booking.data();


                                // const arr= await getBookings(bookingVal,eventId,type)
                                // arr1.push(arr)
                                // setVensBks(arr1)
                                if (bookingVal) {
                                    db.collection('bookings').doc(eventId).collection('ven').doc(uid).get().then(r => {
                                        const value = r.data();
                                        const now = new Date();

                                        if (r.exists) {
                                            if (r.data().status != 'Deleted') {
                                                count++;
                                                const date = new Date(bookingVal.date.toDate());
                                                const owner = bookingVal.owner;

                                                const ven = r.data();
                                                let status = ven.status;


                                                if (now > date) { status = 'Expired'; }
                                                bks.push({
                                                    venueName: ven.name,
                                                    eventId: eventId,
                                                    status: status,
                                                    // user: ven.docid,
                                                    user: bookingVal.owner,
                                                    date: date,
                                                    venueId: ven.venueId,
                                                });
                                                setVensBks(bks);
                                                setVenueBksCount(count);

                                                // return bks
                                            }
                                        }
                                    }).catch((e) => {
                                        if (e.code === 'PERMISSION_DENIED') {
                                            setVensBks(null);
                                        } else { setErr(e); }
                                    });
                                }

                            }).catch((e) => {
                                if (e.code === 'PERMISSION_DENIED') {
                                    setVensBks(null);
                                } else { setErr(e); }
                            });
                        }
                    }


                }
            }).catch((e) => {
                setErr(e);
            });

    };


    const getBookings = (bookingVal, eventId, type) => {
        return db.collection('bookings').doc(eventId).collection('ven').doc(uid).get().then(r => {
            const value = r.data();
            const now = new Date();

            if (r.exists) {

                if (r.data().status != 'Deleted') {
                    // count++
                    const date = new Date(bookingVal.date.toDate());
                    const owner = bookingVal.owner;

                    const ven = r.data();
                    let status = ven.status;

                    if (now > date) { status = 'Expired'; }
                    let obj = {
                        venueName: ven.name,
                        eventId: eventId,
                        status: status,
                        // user: ven.docid,
                        user: bookingVal.owner,
                        date: date,
                        venueId: ven.venueId,
                    };
                    // bks.push({
                    //     venueName: ven.name,
                    //     eventId: eventId,
                    //     status: status,
                    //     // user: ven.docid,
                    //     user:bookingVal.owner,
                    //     date: date,
                    //     venueId: ven.venueId,
                    // })

                    return obj;
                    // setVensBks(bks)
                    // console.log("bks1",bks)
                    // setVenueBksCount(count)
                    //
                    // return bks
                }
            }
        });
    };


    return (
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', backgroundColor: 'var(--drg)', flex: 1, }}>
            {alert && <Alert title="Are you sure?"
                setAlert={setAlert}
                comment={alert.comment}
                options={alert.options}
            />}
            {Err && <div style={{ color: 'red' }}><p style={{ color: 'red' }}>{Err.message}</p></div>}
            <Link to="/edit_venue/new" style={{ alignSelf: 'center', color: 'white', margin: 5 }}>
                Register New Venue
                <FiPlusCircle style={{ marginLeft: 10 }} />
            </Link>

            {
                //mobile ? vensBks &&
            vensBks ?
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <hr style={{ borderBottom: '1px solid var(--ltg)', width: '100%', marginBlock: 5 }} />
                    <p style={{ color: 'white' }}>Bookings:</p>
                    <div style={{ borderBottomColor: "var(--ltg)", borderBottomWidth: 1, paddingHorizontal: 10 }} />
                    <div>
                        {vensBks && vensBksCount == vensBks.length && vensBks.map(item =>
                            <ItemWConf key={item.eventId}
                                item={item}
                                link={() => { console.log('Event', { uid: item.user, eventId: item.eventId }); }}
                                onAccept={() => {
                                    db.collection('bookings').doc(item.eventId).collection('ven').doc(uid).update({ status: 'Booked' }).then(() => {
                                        // setUserState(null);
                                    }).catch(e => { setErr(e); });

                                }}
                                onDecline={() => {
                                    db.collection('bookings').doc(item.eventId).collection('ven').doc(uid).update({ status: 'Canceled' }).then(() => {
                                        // setUserState(null);
                                    }).catch(e => { setErr(e); });

                                }}
                                setAlert={setAlert}
                                onDelete={() => {
                                    db.collection('bookings').doc(item.eventId).collection('ven').doc(uid).update({ status: 'Deleted' }).then(() => {
                                        // setUserState(null); 
                                        setVensBks(null);
                                    }).catch(e => { setErr(e); });

                                }}
                            />
                        )}
                    </div>
                </div>
                : vensBks ?
                    <div style={{ alignItems: 'center' }}>
                        <p style={{ fontSize: 14, marginLeft: 5, color: 'white', textAlign: 'center' }}>Please add your payment account to div your bookings</p>
                    </div>
                    : null

            }
            {actVs &&
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <hr style={{ borderBottom: '1px solid var(--ltg)', width: '100%', marginBlock: 5 }} />
                    <div style={{ borderBottomWidth: 1, paddingHorizontal: 10 }}>
                        <p style={{ color: 'white' }}>Active Venues:</p>
                    </div>
                    <div style={{ width: '100%', }}>
                        {actVs.map(actV =>
                            <div style={{ display: 'flex', flexDirection: 'column', width: '100%', textAlign: 'center' }}>
                                <hr style={{ borderBottom: '1px solid var(--ltg)', width: '100%', marginBlock: 5 }} />
                                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }} >
                                    <Link to={`/venue/${actV.venueId}&${actV.docid}`} style={{ display: 'flex', flexDirection: 'row', }}>
                                        {/* {console.log(actV.docid, actV.venueId, 'actV:', actV)} */}
                                        <div style={{ display: 'flex', flexDirection: 'row' }}
                                            key={actV.venueId}
                                        >
                                            <p style={{ fontSize: 14, marginLeft: 5, color: 'white' }}>{actV.name}</p>
                                        </div>
                                        {/* {console.log(actV)} */}
                                    </Link>
                                    <Link to={`/edit_venue/${actV.docid}`} style={{ display: 'flex', flexDirection: 'row', }}>
                                        <FiEdit style={{ fontSize: 16, color: 'white', marginInlineStart: 5 }} />
                                    </Link>
                                </div>
                                <hr style={{ borderBottom: '1px solid var(--ltg)', width: '100%', marginBlock: 5 }} />
                            </div>
                        )}
                    </div>
                </div>}
        </div>
    );
}
